<template>
  <div>
    <!-- Partita iva -->
    <b-form-group id="group-piva-forn"
      label="* Partita iva del fornitore:"
      label-for="piva"
      :invalidFeedback="invalid_piva_helptext"
      description="Scrivere la partita iva del fornitore, i campi noti saranno riempiti automaticamente"
    >
      <!-- Debounce ritarda l'aggiornamento del dato form.p_iva di 200 millisecondi, utile
           per non caricare il backend di richieste mentre l'utente scrive -->
      <b-form-input
        id="piva-forn"
        v-model="form.p_iva"
        :state="form_state.p_iva"
        :disabled="form_disabled.p_iva"
        list="piva-list"
        placeholder="Partita IVA"
        type="text"
        @keyup="onPivaKeyup"
        @change="onPivaChangeOrBlur"
        @blur="onPivaChangeOrBlur"
        required
      ></b-form-input>

      <!--La datalist contiene i valori tirati su per l'autocomplete al keyup sulla input box -->
      <!--La imput box che la sua deve avere l'attributo "list" settato all'id della datalist -->
      <datalist id="piva-list">
        <option v-for="(piva, index) in piva_datalist" :key="index">{{ piva }}</option>
      </datalist>
    </b-form-group>

    <!-- Ragione sociale -->
    <b-form-group id="group-rag-sociale-forn"
      label="* Ragione sociale del fornitore:"
      label-for="rag-sociale"
    >
      <b-form-input
        id="rag-sociale"
        v-model="form.nome"
        :state="form_state.nome"
        :disabled="form_disabled.nome"
        placeholder="Ragione sociale"
        type="text"
        required
      ></b-form-input>
    </b-form-group>

    <!-- Indiririzzo email del fornitore -->
    <b-form-group id="group-email-forn"
      label="* Indirizzo email del fornitore:"
      label-for="rag-sociale"
    >
      <b-form-input
        id="email-forn"
        v-model="form.email"
        :state="form_state.email"
        :disabled="form_disabled.email"
        placeholder="Email"
        type="email"
        required
      ></b-form-input>
    </b-form-group>

    <!-- Telefono del fornitore -->
    <b-form-group id="group-tel-forn"
      label="* Recapito telefonico del fornitore:"
      label-for="tel-forn"
      :invalidFeedback="invalid_tel_helptext"
    >
      <b-form-input
        id="tel-forn"
        v-model="form.tel"
        :state="form_state.tel"
        :disabled="form_disabled.tel"
        placeholder="Numero di telefono"
        type="tel"
        required
      ></b-form-input>
    </b-form-group>

    <!-- Codice IBAN del fornitore - Visualizzato in base alla prop "use_iban" -->
    <b-form-group v-if="use_iban" id="group-iban-forn"
      label="* Codice IBAN del fornitore:"
      label-for="iban-forn"
      :invalidFeedback="invalid_iban_helptext"
    >
      <p v-if="iban_datalist.length > 0" class="text-success">Sono già disponibili degli iban per questo fornitore, scegline uno oppure digitane uno nuovo.</p>
      <b-form-input
        id="iban-forn"
        list="iban-list"
        v-model="form.iban"
        :state="form_state.iban"
        :disabled="form_disabled.iban"
        @keyup="onIbanKeyup"
        placeholder="Codice IBAN"
        type="text"
        required
      ></b-form-input>

      <datalist id="iban-list">
        <option v-for="(iban, index) in iban_datalist" :key="index">{{ iban }}</option>
      </datalist>
    </b-form-group>

  </div>
</template>

<script>
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'
import iban from 'iban'


export default {
  name: 'FormFornitore',
  data () {
    return {
      // Elementi della datalist per l'autocomplete sulla partita iva
      piva_datalist : [],

      // Iban già esistenti per il fornitore ( se definiti )
      iban_datalist : [],

      // Stato disabilitato/abilitato del form
      form_disabled : {
        p_iva : false,
        nome : false,
        email : false,
        tel : false,
        iban : false
      },

      // Stato dei dati del form per la validazione
      form_state : {
        p_iva : null,
        nome : null,
        email : null,
        tel : null,
        iban : null
      },

      // Dati del form
      form : {
        p_iva : null,
        nome : null,
        email : null,
        tel : null,
        iban : null
      }
    }
  },
  computed : {
    /**
     * Se lo stato della partita iva non è corretto visualizza un testo
     * di help per l'utente.
     */
    invalid_piva_helptext : function () {
      if ( this.form_state.p_iva === false ){
        return 'Partita iva non valida';
      } else {
        return '';
      }
    },
    /**
     * Se lo stato dell'iban non è corretto visualizziamo il testo di help
     * per l'utente.
     */
    invalid_iban_helptext : function () {
      if ( this.form_state.iban === false ){
        return 'Codice IBAN non valido';
      } else {
        return '';
      }
    },
    /**
     * Se lo stato del numero di telefono non è corretto visualizziamo il testo di help
     * per l'utente.
     */
    invalid_tel_helptext : function () {
      if ( this.form_state.tel === false ){
        return 'Il numero di telefono non può contenere lettere.';
      } else {
        return '';
      }
    }
  },
  methods : {
    /**
     * Ricerca le partite iva dei fornitori che iniziano con il valore
     * inserito e popola la datalist per l'autocomplete
     */
    onPivaKeyup : function ( evt ) {

      // Ad inizio ricerca resettiamo i campi se questi erano stati autofillati
      this.resetta_autofill_campi();

      // Se stiamo tentando di immettere più di 11 cifre blocchiamo l'inserimento
      if ( this.form.p_iva.length > 11 ){
        this.form.p_iva = this.form.p_iva.slice(0,11);
      }

      // La ricerca la iniziamo dopo la seconda cifra immessa
      if ( this.form.p_iva.length < 2 ) {
        return;
      }

      // Usiamo il parametro get limit per limitare i risultati solo ai primi 10
      let api_url = apiUrl.welfareapi.anagrafica_fornitore_by_term.replace('@term', 'p_iva').replace('@term_val', this.form.p_iva );
      axios.get( api_url, { params: { limit : 10 } } )
      .then( (response) => {
        this.piva_datalist = []
        for ( let elem of response.data ) {
          this.piva_datalist.push( elem.p_iva );
        }
      })
      .catch ( ( error ) => {
        console.error( error.response.data );
      });

    },
    /**
     * Quando il valore della partita iva cambia all'onchange perchè selezionato dall'autocomplete
     * oppure se passiamo ad un altro campo perchè l'utente scrive autonomamente il valore, se il campo
     * è correttamente validato andiamo a cercarlo tra i fornitori disponibili e facciamo l'autofill dei
     * campi del form.
     */
    onPivaChangeOrBlur : function ( evt ) {

      if ( this.form_state.p_iva === true ) {

        let api_url = apiUrl.welfareapi.anagrafica_fornitore_by_term.replace('@term', 'p_iva').replace('@term_val', this.form.p_iva );

        axios.get( api_url )
        .then( (response) => {

          // Siccome cerchiamo una partita iva conosciuta e completa il dato
          // di ritorno deve essere un'array di un solo elemento, se non è così
          // c'è qualcosa che non va!
          if ( response.data.length > 1 ) {
            generalLib.backend_error_message_box( this, 'Impossibile trovare il fornitore.' );
            console.error( "Risultati multipli durante la ricerca del fornitore noto." );
          } else {
            this.esegui_autofill_campi( response.data[0] );
          }

        })
        .catch ( ( error ) => {
          console.error( error.response.data );
        });
      }

    },
    /**
     * Fa in modo che il campo iban non possa essere scritto con caratteri separatori
     * e con lettere piccole, rimuove quindi tutti i caratteri che non sono lettere o numeri
     * e porta tutto in maiuscolo.
     */
    onIbanKeyup : function () {
      this.form.iban = this.form.iban.replace(/[^A-Za-z0-9]/ig,'').toUpperCase();
    },
    /**
     * Dati i valori di un fornitore esegue l'autofill dei campi, li colora in verde e li blocca.
     */
    esegui_autofill_campi : function ( fornitore ) {

      // Nome
      if ( fornitore.cognome !== null && fornitore.cognome !== '' ) {
        this.form.nome = fornitore.nome + ' ' + fornitore.cognome;
      } else {
        this.form.nome = fornitore.nome;
      }
      this.form_state.nome = true;
      this.form_disabled.nome = true;

      // Email ( la riempio se nota altrimenti la faccio inserire )
      if ( fornitore.email !== null && fornitore.email !== "" ) {
        this.form.email = fornitore.email
        this.form_state.email = true;
        this.form_disabled.email = true;
      }

      // Telefono ( lo riempio se noto altrimenti lo faccio inserire )
      if ( fornitore.tel !== null && fornitore.tel !== "" ) {
        this.form.tel = fornitore.tel
        this.form_state.tel = true;
        this.form_disabled.tel = true;
      }

      // IBAN ( se in uso )
      // Siccome l'iban può essere più di uno non faccio
      // l'autofill del campo ma popolo la datalist per dare l'opportunità
      // all'utente di scegliere tra gli iban già disponibili oppure di metterne
      // uno nuovo.
      if ( this.use_iban && fornitore.iban.length > 0 ) {
        this.iban_datalist = [];
        for ( let elem of fornitore.iban ) {
          this.iban_datalist.push( elem.iban );
        }
      }

    },
    /**
     * Resetta i campi allo stato iniziale se erano stati riempiti automaticamente,
     * Il campo della partita iva è escluso in quanto è l'unico che non può andare in autofill.
     */
    resetta_autofill_campi : function ( exclude_piva = false ) {

      // Nome
      if ( this.form_disabled.nome ) {
        this.form.nome = null;
        this.form_state.nome = null;
        this.form_disabled.nome = false;
      }

      // Email
      if ( this.form_disabled.email ) {
        this.form.email = null
        this.form_state.email = null;
        this.form_disabled.email = false;
      }

      // Telefono
      if ( this.form_disabled.tel ) {
        this.form.tel = null
        this.form_state.tel = null;
        this.form_disabled.tel = false;
      }

      // IBAN ( se in uso )
      if ( this.use_iban ) {
        this.iban_datalist = [];
        this.form.iban = null;
        this.form_state.iban = null;
      }
    },
    /**
     * Emette l'evento fornDataChanged che notifica al ricevente
     * i nuovi dati del form.
     * La notifica avviene solo se i campi speciali come iban e partita
     * iva solo correttamente validati, altrimenti viene riassegnato il null
     * per norificare che i dati non sono disponibili.
     */
    notifica_nuovi_dati : function () {

      // prepariamo l'oggetto da tornare copiando quello interno del form.
      // per distinguere questi dati da altri eventualmente presenti nel chiamante
      // aggiungiamo la desinenza '_forn' alle chiavi.
      let data = {}
      for ( let key in this.form ) {
        let new_key = key + '_forn';
        data[ new_key ] = this.form[ key ];
      }

      if ( this.use_iban && this.form_state.iban === true &&  this.form_state.p_iva === true && this.form_state.tel === true ) {
        // Usando l'iban lo trasformo in caratteri grandi
        data [ 'iban_forn' ] = data [ 'iban_forn' ].toUpperCase();
        this.$emit( 'fornDataChanged', data );
      } else if ( ! this.use_iban && this.form_state.p_iva === true && this.form_state.tel === true ) {
        // Non usando l'iban lo rimuovo dai dati passati al chiamante.
        delete data.iban_forn;
        this.$emit( 'fornDataChanged', data );
      } else {
        this.$emit( 'fornDataChanged', null );
      }

    }
  },
  watch : {
    /**
     * Controlliamo e validiamo il telefono con la proprità state del form
     * ammettiamo numeri e simboli, non ammettiamo lettere.
     */
    'form.tel' : function ( val ) {
      if ( val === '' ) {
        this.form_state.tel = null;
      } else if ( generalLib.phone_is_valid( val ) ) {
        this.form_state.tel = true;
      } else {
        this.form_state.tel = false;
      }
    },
    /**
     * Controlliamo e validiamo l'iban con la proprità state del form
     */
    'form.iban' : function ( val ) {
      if ( val === '' ) {
        this.form_state.iban = null;
      } else if ( iban.isValid( val ) ) {
        this.form_state.iban = true;
      } else {
        this.form_state.iban = false;
      }
    },
    /**
     * Controlliamo e validiamo la partita iva con la proprietà state del form
     */
    'form.p_iva' : function ( val ) {
      if ( val === '' ) {
        this.form_state.p_iva = null;
      } else if ( ! generalLib.piva_is_valid ( val ) ) {
        this.form_state.p_iva = false;
      } else {
        this.form_state.p_iva = true;
      }
    },
    /**
     * Solo in ultimo, dopo le validazioni, controlla la modifica dei campi del form e lo notifica al chiamante.
     * In questa versione con deep e l'handler andiamo a verificare lo stato
     * di tutto l'oggetto form:
     * https://stackoverflow.com/questions/42133894/vue-js-how-to-properly-watch-for-nested-data
     */
    form: {
      handler( val ){
        this.notifica_nuovi_dati();
      },
      deep: true
    },
    /**
     * Se viene passata la prop load_fornitore_by_piva per il preset dei dati del fornitore
     * andiamo ad aggiornare il relativo campo del form.
     */
    load_fornitore_by_piva: function ( val ) {
      this.form.p_iva = val;

      // Assumiamo come valida l'iva del fornitore ( gliela passa il backend... )
      // altrimenti la validazione del campo ha seguito quando già la funzione
      // onPivaChangeOrBlur è terminata e quindi la onPivaChangeOrBlur senza che il
      // campo sia valido non viene eseguita.
      this.form_state.p_iva = true;

      this.onPivaChangeOrBlur();
    }
  },
  props : {
    /**
    * Indica se visualizzare anche il campo dell'iban come input o meno.
    */
    use_iban: {
      type: Boolean,
      default : false
    },
    /**
     * Utile se il form deve essere precaricato con un fornitore già noto
     * (es. se siamo in modalità replay dell'acquisto). In questo modo carichiamo
     * direttamente i dati del fornitore la cui partita iva è quella passata.
     */
    load_fornitore_by_piva: {
      type: String,
      default : null
    }
  },
  components: {
  }
}
</script>

<style scoped></style>

